export default __webpack_public_path__ + "static/media/linkedin.bbe0e3e6.png";